import { Link } from 'react-router-dom-v5-compat';
import { Typography } from '@mui/material';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import DraftsIcon from '@mui/icons-material/Drafts';

import { formatPhone, currentYear, pages } from 'common';
import EmailLink from '../EmailLink';
import { useAppSettings } from '../../contexts';
import { Logo } from '../Logo';
import PageContainer from '../PageContainer/PageContainer';

const Footer = () => {
  const {
    appSettings: { compactLogo, name, phone, email },
  } = useAppSettings();

  return (
    <footer className="border-t border-t-gray-300">
      <PageContainer className="flex justify-between items-center py-4">
        <div>
          <Typography>© {currentYear} HarvestIQ, Inc.</Typography>
          <Typography>All Rights Reserved</Typography>
          <Link to={pages.termsAndConditions.path} className="!text-black">
            Terms of Service
          </Link>
        </div>
        <div className="!hidden md:!flex">
          <Logo logoUrl={compactLogo} imgAlt={name} size={32} />
        </div>
        <div>
          {phone && (
            <Typography className="space-x-2">
              <LocalPhoneIcon fontSize="inherit" data-cy="LocalPhoneIcon" />
              <a href={`tel:1${phone}`} className="!text-black">
                {formatPhone(phone)}
              </a>
            </Typography>
          )}
          {email && (
            <Typography className="space-x-2">
              <DraftsIcon fontSize="inherit" data-cy="DraftsIcon" />
              <EmailLink email={email} className="!text-black" />
            </Typography>
          )}
        </div>
      </PageContainer>
    </footer>
  );
};

export default Footer;
